import { createContext, useContext } from 'react';

interface ClientUpdateNotificationContextType {
  isPuppeteer: boolean;
  setIsPuppeteer: (isPuppeteer: boolean) => void;
}

export const ClientUpdateNotificationContext =
  createContext<ClientUpdateNotificationContextType>(
    {} as ClientUpdateNotificationContextType
  );

export const useClientUpdateNotificationContext = () => {
  return useContext(ClientUpdateNotificationContext);
};
